import { InjectionToken, Inject, Input, HostBinding, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { __decorate, __param } from 'tslib';
import { tuiDefaultProp } from '@taiga-ui/cdk';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';
import { TuiWrapperModule } from '@taiga-ui/core/directives/wrapper';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

/** Default values for the checkbox options. */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core/directives/wrapper';
import * as ɵngcc2 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc3 from '@taiga-ui/core/components/svg';

function TuiPrimitiveCheckboxComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 2);
} if (rf & 2) {
    const icon_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("mark_on", !ctx_r0.empty);
    ɵngcc0.ɵɵproperty("src", icon_r1);
} }
const _c0 = function (a0) { return { $implicit: a0 }; };
const _c1 = ["*"];
const TUI_CHECKBOX_DEFAULT_OPTIONS = {
    size: 'm',
    appearances: {
        unchecked: "outline" /* Outline */,
        checked: "primary" /* Primary */,
        indeterminate: "primary" /* Primary */,
    },
    icons: {
        checked({ $implicit }) {
            return $implicit === 'm' ? 'tuiIconCheck' : 'tuiIconCheckLarge';
        },
        indeterminate({ $implicit }) {
            return $implicit === 'm' ? 'tuiIconMinus' : 'tuiIconMinusLarge';
        },
    },
};
const TUI_CHECKBOX_OPTIONS = new InjectionToken('Default parameters for checkbox component', {
    factory: () => TUI_CHECKBOX_DEFAULT_OPTIONS,
});
const tuiCheckboxOptionsProvider = (options) => ({
    provide: TUI_CHECKBOX_OPTIONS,
    useValue: Object.assign(Object.assign({}, TUI_CHECKBOX_DEFAULT_OPTIONS), options),
});

// @dynamic
let TuiPrimitiveCheckboxComponent = class TuiPrimitiveCheckboxComponent {
    constructor(options) {
        this.options = options;
        this.size = this.options.size;
        this.disabled = false;
        this.focused = false;
        this.hovered = false;
        this.pressed = false;
        this.invalid = false;
        this.icon = this.options.icons.checked;
        this.value = false;
    }
    set valueSetter(value) {
        if (value !== false) {
            this.setCurrentIcon(value);
        }
        this.value = value;
    }
    get appearance() {
        switch (this.value) {
            case false:
                return this.options.appearances.unchecked;
            case true:
                return this.options.appearances.checked;
            default:
                return this.options.appearances.indeterminate;
        }
    }
    get empty() {
        return this.value === false;
    }
    setCurrentIcon(value) {
        this.icon =
            value === null
                ? this.options.icons.indeterminate
                : this.options.icons.checked;
    }
};
TuiPrimitiveCheckboxComponent.ɵfac = function TuiPrimitiveCheckboxComponent_Factory(t) { return new (t || TuiPrimitiveCheckboxComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_CHECKBOX_OPTIONS)); };
TuiPrimitiveCheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiPrimitiveCheckboxComponent, selectors: [["tui-primitive-checkbox"]], hostVars: 1, hostBindings: function TuiPrimitiveCheckboxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-size", ctx.size);
    } }, inputs: { size: "size", disabled: "disabled", focused: "focused", hovered: "hovered", pressed: "pressed", invalid: "invalid", valueSetter: ["value", "valueSetter"] }, ngContentSelectors: _c1, decls: 4, vars: 10, consts: [[3, "appearance", "disabled", "focused", "hovered", "pressed", "invalid"], ["polymorpheus-outlet", "", 3, "content", "context"], [1, "mark", 3, "src"]], template: function TuiPrimitiveCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "tui-wrapper", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, TuiPrimitiveCheckboxComponent_ng_template_2_Template, 1, 3, "ng-template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("appearance", ctx.appearance)("disabled", ctx.disabled)("focused", ctx.focused)("hovered", ctx.hovered)("pressed", ctx.pressed)("invalid", ctx.invalid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("content", ctx.icon)("context", ɵngcc0.ɵɵpureFunction1(8, _c0, ctx.size));
    } }, directives: [ɵngcc1.TuiWrapperDirective, ɵngcc2.PolymorpheusOutletComponent, ɵngcc3.TuiSvgComponent], styles: ["[_nghost-%COMP%]{display:block;font-size:0;flex-shrink:0}[data-size='m'][_nghost-%COMP%]{width:1rem;height:1rem;border-radius:var(--tui-radius-xs)}[data-size='l'][_nghost-%COMP%]{width:1.5rem;height:1.5rem;border-radius:var(--tui-radius-s)}.mark[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:block;width:100%;height:100%;transform:scale(0)}.mark_on[_ngcontent-%COMP%]{transform:scale(1)}"], changeDetection: 0 });
TuiPrimitiveCheckboxComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_CHECKBOX_OPTIONS,] }] }
];
__decorate([
    Input(),
    HostBinding('attr.data-size'),
    tuiDefaultProp()
], TuiPrimitiveCheckboxComponent.prototype, "size", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveCheckboxComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveCheckboxComponent.prototype, "focused", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveCheckboxComponent.prototype, "hovered", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveCheckboxComponent.prototype, "pressed", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveCheckboxComponent.prototype, "invalid", void 0);
__decorate([
    Input('value'),
    tuiDefaultProp()
], TuiPrimitiveCheckboxComponent.prototype, "valueSetter", null);
TuiPrimitiveCheckboxComponent = __decorate([ __param(0, Inject(TUI_CHECKBOX_OPTIONS))
], TuiPrimitiveCheckboxComponent);

let TuiPrimitiveCheckboxModule = class TuiPrimitiveCheckboxModule {
};
TuiPrimitiveCheckboxModule.ɵfac = function TuiPrimitiveCheckboxModule_Factory(t) { return new (t || TuiPrimitiveCheckboxModule)(); };
TuiPrimitiveCheckboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiPrimitiveCheckboxModule });
TuiPrimitiveCheckboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[TuiSvgModule, TuiWrapperModule, PolymorpheusModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiPrimitiveCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'tui-primitive-checkbox',
                template: "<tui-wrapper\n    [appearance]=\"appearance\"\n    [disabled]=\"disabled\"\n    [focused]=\"focused\"\n    [hovered]=\"hovered\"\n    [pressed]=\"pressed\"\n    [invalid]=\"invalid\"\n>\n    <span\n        polymorpheus-outlet\n        [content]=\"icon\"\n        [context]=\"{$implicit: size}\"\n    >\n        <ng-template let-icon>\n            <tui-svg\n                class=\"mark\"\n                [class.mark_on]=\"!empty\"\n                [src]=\"icon\"\n            ></tui-svg>\n        </ng-template>\n    </span>\n    <ng-content></ng-content>\n</tui-wrapper>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:block;font-size:0;flex-shrink:0}:host[data-size='m']{width:1rem;height:1rem;border-radius:var(--tui-radius-xs)}:host[data-size='l']{width:1.5rem;height:1.5rem;border-radius:var(--tui-radius-s)}.mark{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:block;width:100%;height:100%;transform:scale(0)}.mark_on{transform:scale(1)}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_CHECKBOX_OPTIONS]
            }] }]; }, { size: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-size']
        }], disabled: [{
            type: Input
        }], focused: [{
            type: Input
        }], hovered: [{
            type: Input
        }], pressed: [{
            type: Input
        }], invalid: [{
            type: Input
        }], valueSetter: [{
            type: Input,
            args: ['value']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiPrimitiveCheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [TuiSvgModule, TuiWrapperModule, PolymorpheusModule],
                declarations: [TuiPrimitiveCheckboxComponent],
                exports: [TuiPrimitiveCheckboxComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiPrimitiveCheckboxModule, { declarations: function () { return [TuiPrimitiveCheckboxComponent]; }, imports: function () { return [TuiSvgModule, TuiWrapperModule, PolymorpheusModule]; }, exports: function () { return [TuiPrimitiveCheckboxComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_CHECKBOX_DEFAULT_OPTIONS, TUI_CHECKBOX_OPTIONS, TuiPrimitiveCheckboxComponent, TuiPrimitiveCheckboxModule, tuiCheckboxOptionsProvider };

